/**
 * Created by ModelParser
 * Date: 17-09-2022.
 * Time: 15:20.
 */
import {MeasurementDefinition} from './definitions/MeasurementDefinition';
import {Client} from "@/core/services/MedicaPro/models/Client";
import {MeasurementIdentifierHelper} from "@/helpers/MeasurementIdentifierHelper";
import {MeasurementCategories} from "@/Constants";

export class Measurement extends MeasurementDefinition {

    constructor(json?: any) {
        super(json);
    }

    public static Create(client: Client, identifier?: string): Measurement {
        const item = new Measurement();
        item.client_id = client.id;
        item.measurement_type_identifier = identifier;
        return item;
    }

    public getDate(): Date {
        return new Date(this.date ?? '');
    }

    public getHtmlComment(): string {
        return this.comment?.replaceAll("\n", "<br>") ?? '';
    }

    public get smartValue(): number {
        return this.value_override ?? this.value ?? -1;
    }

    public get category(): string {
        if (MeasurementIdentifierHelper.Symptoms().includes(this.measurement_type_identifier!)) {
            return MeasurementCategories.Symptoms;
        } else if (MeasurementIdentifierHelper.ObjectivePsychic().includes(this.measurement_type_identifier!)) {
            return MeasurementCategories.ObjectivePsychic;
        } else if (MeasurementIdentifierHelper.Anamnesis().includes(this.measurement_type_identifier!)) {
            return MeasurementCategories.Anamnesis;
        } else {
            return '';
        }
    }

}
